import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import { Chart } from 'react-google-charts';

import { LocalizationContext } from '../../../../AppContext';
import Label, { LabelPie } from '../../../../components/Label';

import localization from './InfoCityMandates.local';

export default function InfoCityMandates({
  absolute,
  councilParties,
  mandates,
}) {
  const local = localization[useContext(LocalizationContext)];

  return (
    <Paper sx={{ width: '100%', p: 1, pb: 2 }}>
      <Typography variant="h6">{local.title}</Typography>
      { councilParties ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Chart
              chartType="PieChart"
              height="100%"
              width="300px"
              data={[
                [local.party, local.mandates],
                ['filler', 100],
                ...councilParties
                  .sort((a, b) => b.mandate - a.mandates)
                  .map((item) => ([
                    `${Math.round((item.mandates / mandates) * 10000) / 100}%`,
                    Math.round((item.mandates / mandates) * 10000) / 100,
                  ])),
              ]}
              loader={<Skeleton variant="rect" style={{ height: '100%', width: '100%' }} />}
              options={{
                enableInteractivity: false,
                chartArea: { width: '100%', height: '100%' },
                legend: 'none',
                tooltip: { position: 'none' },
                backgroundColor: 'transparent',
                pieSliceText: 'label',
                pieHole: 0.4,
                pieStartAngle: 90,
                slices: [{ color: 'transparent' }, ...councilParties.map((item) => ({ color: item.color || 'grey' }))],
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Label label={local.mandatesTotal} value={mandates} />
            <LabelPie label={local.absolute} value={absolute ? absolute.name : local.noAbsolute} color={absolute ? absolute.color : local.noAbsoluteColor} />
            { councilParties.sort((a, b) => b.mandate - a.mandates).map((party) => (
              <LabelPie
                key={party.id}
                label={`${party.name} ${local.mandates}`}
                value={`${party.mandates} (${Math.round((party.mandates / mandates) * 10000) / 100}%)`}
                color={party.color}
              />
            )) }
          </Grid>
        </Grid>
      ) : (
        <Typography>{local.noCouncilParties}</Typography>
      )}
    </Paper>
  );
}

InfoCityMandates.propTypes = {
  absolute: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
  }),
  councilParties: PropTypes.arrayOf(PropTypes.shape({})),
  mandates: PropTypes.number.isRequired,
};

InfoCityMandates.defaultProps = {
  absolute: undefined,
  councilParties: undefined,
};
